import type { AxiosRequestConfig } from "axios"
import { useMemo } from "react"

// this is the key for the cached follows data
export function useFollowsSWRKey(): AxiosRequestConfig | undefined {
  const swrKey = useMemo(
    () => {
      const url = "/api/v3/follows"

      return {
        url,
      }
    },
    [],
  )

  return swrKey
}
